import{Dropdown as t}from"react-bootstrap";import o from"styled-components";import{COLORS as i}from"../../constants/Theme.js";var r,e,n;!function(t){t.TOP_LEFT="top left",t.TOP_RIGHT="top right",t.BOTTOM_LEFT="bottom left",t.BOTTOM_RIGHT="botton right"}(r||(r={})),function(t){t.UP="up",t.UP_CENTERED="up-centered",t.START="start",t.END="end",t.DOWN="down",t.DOWN_CENTERED="down-centered"}(e||(e={})),function(t){t.START="start",t.END="end"}(n||(n={}));const d=o.div`
	width: ${t=>t.width}px;
	height: ${t=>t.height}px;
	background: ${t=>t.color};
	${t=>t.isRound?"border-radius: 50%;":"border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; border-top-left-radius:50%;"}
	justify-content: center;
	align-items: center;
	cursor: pointer;
	display: flex;
`,p=o.div`
	display: flex;
	border-radius: 50%;
	flex-direction: column;
	align-items: flex-end;
	position: fixed;
	width: ${t=>t.width}px;
	height: ${t=>t.height}px;
	z-index: ${t=>t.zIndex};
	${t=>t.position===r.BOTTOM_RIGHT?`right: ${t.buttonPaddingHorizontal}px; bottom: ${t.buttonPaddingVertical}px`:t.position===r.BOTTOM_LEFT?`left: ${t.buttonPaddingHorizontal}px; bottom: ${t.buttonPaddingVertical}px`:t.position===r.TOP_LEFT?`left: ${t.buttonPaddingHorizontal}px; top: ${t.buttonPaddingVertical}px`:t.position===r.TOP_RIGHT?`right: ${t.buttonPaddingHorizontal}px; top: ${t.buttonPaddingVertical}px`:""};
`,a=o(t)`
	.filter-container {
		.single-row {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			gap: 8px;
			padding: 14px;
			border-bottom: 1px solid ${i.stroke.primary};

			:last-child {
				border-bottom: none !important;
			}
		}
	}
	button {
		border: 1px solid
			${t=>"true"===t.active?i.stroke.positive.lightAlt:i.stroke.primary};
		border-radius: 4px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 6px 0px;
		background: ${t=>"true"===t.active?i.background.positive.light:i.surface.standard};
		color: ${t=>"true"===t.active?i.content.positive:i.content.primary};
	}

	.btn-primary:hover,
	.btn-primary:active,
	.btn-primary:focus,
	.btn-primary.dropdown-toggle,
	.show > .btn-primary.dropdown-toggle {
		color: ${t=>"true"===t.active?i.content.positive:i.content.primary};
		background-color: ${t=>"true"===t.active?i.background.positive.light:"transparent"};
		border: none;
	}
	.btn:focus {
		outline: 0;
		box-shadow: 0 0 0 0.25rem transparent !important;
	}

	.dropdown-toggle::after {
		border-top: 0.3em solid ${i.content.primary};
		display: none !important;
	}

	.dropdown-toggle::before {
		border-top: 0.3em solid ${i.content.primary};
		display: none !important;
	}
	.dropdown-menu {
		min-width: 12rem;
		padding: 0 0;
	}
	.dropdown-item:active,
	.dropdown-item:hover {
		color: ${i.content.positive};
		text-decoration: none;
		background-color: ${i.background.positive.light};
	}
`,s=o(t.Toggle)`
	border-radius: 4px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 6px 8px;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
`,l=o.div`
	box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	padding: 8px;
	background-color: ${i.content.primary};
	color: ${i.content.primaryInverse};
	width: ${t=>t.tooltipWidth?t.tooltipWidth+"px":"120px"};
`;export{e as DROP_POSITION,s as DropdownToggleContainer,r as FAB_POSITION,d as FloatingActionButtonContainer,p as FloatingActionButtonOuterContainer,n as MENU_ALIGNMENT,a as StyledDropdown,l as TooltipStyled};
